/* src/app/dialog/dialog.component.css */
.md-dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5001;
  background-color: #fff;
  border-radius: 25px;
  border: 4px solid #73AD21;
  padding: 10px;
}
/*# sourceMappingURL=dialog.component-ZSPTQXD4.css.map */
